import { useSessionStorage } from "../misc/useSessionStorage";

export const useCurrentSessionDate = () => {
  const [sessionDate, setCurrentSessionDate] = useSessionStorage<string | null>(
    "current_date"
  );
  return { sessionDate, setCurrentSessionDate };
};
